export const clearinghouses = [
  {
    name: 'Availity',
    initials: 'AV',
    color: '#0072CE',
    tagline: 'Real-Time Eligibility & Benefits Verification',
    description: "Availity is the nation's largest real-time health information network, connecting providers with health plans for seamless eligibility verification and benefits lookup.",
    features: [
      'Real-time eligibility verification across 2,000+ payers',
      'Benefits lookup with detailed coverage information',
      'Member ID card retrieval and verification',
      'Automated batch eligibility processing',
      'Prior authorization status tracking',
      'HIPAA-compliant secure data exchange',
    ],
    keysNeeded: ['Client ID', 'Client Secret', 'NPI', 'Tax ID'],
    status: 'Ready for Integration',
  },
  {
    name: 'Waystar',
    initials: 'WS',
    color: '#00A651',
    tagline: 'Full Revenue Cycle Management Suite',
    description: 'Waystar simplifies and unifies the healthcare revenue cycle with cloud-based technology. From eligibility to final payment, Waystar covers every step of the RCM process.',
    features: [
      'End-to-end revenue cycle management',
      'Eligibility verification and benefits discovery',
      'Electronic claims submission and tracking',
      'Prior authorization automation',
      'Payment posting and reconciliation',
      'Denial management and appeals workflow',
      'Electronic remittance advice (ERA) processing',
    ],
    keysNeeded: ['Client ID', 'Client Secret', 'Organization ID'],
    status: 'Ready for Integration',
  },
  {
    name: 'Office Ally',
    initials: 'OA',
    color: '#E31837',
    tagline: 'EDI Clearinghouse — 6,000+ Payers',
    description: 'Office Ally connects healthcare providers to over 6,000 insurance payers through a single EDI clearinghouse platform. Streamline claims, verify eligibility, and process remittances all in one place.',
    features: [
      'EDI clearinghouse with 6,000+ payer connections',
      'Real-time eligibility verification',
      'Electronic claims submission with real-time status',
      'Electronic remittance advice (ERA)',
      'Claim scrubbing and error detection',
      'Batch claim processing and reporting',
    ],
    keysNeeded: ['Client ID', 'Client Secret', 'Username', 'Password', 'Submitter ID'],
    status: 'Ready for Integration',
  },
];

export const suppliers = [
  {
    name: 'NikoHealth',
    initials: 'NH',
    color: '#4A90D9',
    category: 'Full-Service DME',
    description: 'Cloud-based DME/HME business management platform with end-to-end order processing, inventory management, and billing automation.',
    specialties: ['DME Order Management', 'Inventory Tracking', 'Automated Billing', 'Delivery Scheduling'],
  },
  {
    name: 'McKesson',
    initials: 'MK',
    color: '#0057A0',
    category: 'Medical Distribution',
    description: 'One of the largest healthcare supply chain companies in the world. McKesson distributes pharmaceuticals, medical supplies, and DME products across North America.',
    specialties: ['Medical Supplies', 'Pharmaceutical Distribution', 'Healthcare Technology', 'Supply Chain Solutions'],
  },
  {
    name: 'Medline',
    initials: 'ML',
    color: '#00843D',
    category: 'Medical Products Manufacturer',
    description: 'Medline is the largest privately held manufacturer and distributor of healthcare supplies in the US, serving hospitals, nursing homes, and DME providers.',
    specialties: ['Patient Care Products', 'Wound Care', 'Respiratory Products', 'Mobility Equipment'],
  },
  {
    name: 'Rotech',
    initials: 'RT',
    color: '#1E3A5F',
    category: 'Home Medical Equipment',
    description: 'National provider of home medical equipment and respiratory services, serving over 1 million patients annually across 46 states.',
    specialties: ['CPAP/BiPAP Equipment', 'Oxygen Therapy', 'Enteral Nutrition', 'Nebulizers'],
  },
  {
    name: 'AdaptHealth',
    initials: 'AH',
    color: '#7B2D8E',
    category: 'Home Health Equipment',
    description: 'One of the largest HME companies in the US, providing home medical equipment, supplies, and related services to over 4 million patients.',
    specialties: ['Sleep Therapy (CPAP)', 'Respiratory Equipment', 'Diabetes Supplies', 'Home Accessibility'],
  },
  {
    name: 'Byram Healthcare',
    initials: 'BH',
    color: '#F47920',
    category: 'Direct-to-Patient Supplies',
    description: "Leading national supplier of medical supplies shipped directly to patients' homes, specializing in diabetes, ostomy, urology, and wound care supplies.",
    specialties: ['Diabetes Supplies', 'Ostomy Products', 'Urology Supplies', 'Wound Care'],
  },
  {
    name: 'National Seating & Mobility',
    initials: 'NS',
    color: '#B71C1C',
    category: 'Complex Rehab Technology',
    description: "The nation's leading provider of complex rehabilitation technology, including custom wheelchairs, seating systems, and mobility solutions for individuals with disabilities.",
    specialties: ['Power Wheelchairs', 'Custom Seating', 'Manual Wheelchairs', 'Accessibility Solutions'],
  },
  {
    name: 'Hanger Clinic',
    initials: 'HC',
    color: '#005A9E',
    category: 'Orthotics & Prosthetics',
    description: 'The largest provider of orthotic and prosthetic services in the US, with over 800 patient care clinics providing advanced O&P solutions.',
    specialties: ['Custom Prosthetics', 'Orthotics', 'Pediatric O&P', 'Sports Medicine Bracing'],
  },
  {
    name: 'Apria',
    initials: 'AP',
    color: '#009CDE',
    category: 'Home Healthcare Services',
    description: "One of the nation's leading home healthcare equipment providers, delivering respiratory therapy, sleep management, and home medical equipment.",
    specialties: ['Sleep Apnea Therapy', 'Home Oxygen', 'Negative Pressure Wound Therapy', 'Enteral Nutrition'],
  },
  {
    name: 'DDP Medical',
    initials: 'DD',
    color: '#2E7D32',
    category: 'DME Distribution',
    description: 'Regional DME distributor specializing in durable medical equipment fulfillment, warehousing, and logistics for healthcare providers.',
    specialties: ['DME Fulfillment', 'Warehousing', 'Logistics', 'Equipment Maintenance'],
  },
];
